import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const ApiStatusCard = ({ apiStatus }) => (
  <Card className="mt-4 border-slate-200">
    <CardContent className="p-4">
      <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
        Sandata API
      </h4>
      <div className="space-y-1.5 text-xs">
        <div className="flex justify-between">
          <span className="text-slate-500">Mode</span>
          <span className="font-medium text-slate-800">
            {apiStatus?.mode?.toUpperCase() || '...'}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">Account</span>
          <span className="font-mono text-slate-800">{apiStatus?.test_account || '...'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">Provider</span>
          <span className="font-mono text-slate-800">{apiStatus?.provider_id || '...'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">Status</span>
          <div className="flex items-center gap-1.5">
            <div
              className={`w-2 h-2 rounded-full ${
                apiStatus?.configured ? 'bg-emerald-500' : 'bg-red-500'
              }`}
            />
            <span className="text-slate-800">
              {apiStatus?.configured ? 'Connected' : 'Not configured'}
            </span>
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default ApiStatusCard;
